import clsx from 'clsx';
import { FC } from 'react';
import { useDrop } from 'react-dnd';
import { DnDTypes } from 'types/elearning';
import { DragSource } from '../text-dnd';
import cls from './drop-zone.module.scss';
import { ReactComponent as StatusFailedIcon } from 'assets/images/elearning/topic-status/status_failed_type_2.svg';
import { ReactComponent as StatusSuccessIcon } from 'assets/images/elearning/topic-status/status_success_type_2.svg';

interface IProps {
    id: string;
    handleDrop: (
        dropzoneId: string,
        elementId: string,
        removeFromPreviousPosition: boolean
    ) => void;
    description: string;
    image_url?: string;
    image: [string, string];
    coordinate: {x: number, y: number, hoverText: string, finishText: string},
    isCorrect: boolean | undefined;
}

function itemToLetter(itemKey: string): string {
    const number = parseInt(itemKey.split('_')[1], 10);
    return String.fromCharCode(96 + number);
}

export const DropZone: FC<IProps> = ({
    id,
    handleDrop,
    description,
    image_url,
    image,
    coordinate,
    isCorrect,
}) => {
    const [{ isOver }, dropRef] = useDrop(() => ({
        accept: DnDTypes.MATCH_IMAGE_WITH_DESCRIPTION,
        drop: (item: { draggedElementId: string; source: DragSource }) => {
            handleDrop(
                id,
                item?.draggedElementId,
                item?.source === 'drop-area' ? true : false
            );
        },
        collect: (monitor) => ({
            isOver: !!monitor.isOver(),
            canDrop: !!monitor.canDrop(),
        }),
    }));
    
    const clsDropzone = clsx(cls.dropzone, {
        [cls.dropzoneOver]: isOver,
        [cls.dropzoneWithImg]: !isOver && Boolean(image_url),
        [cls.finished]: isCorrect !== undefined,
    });
    
    return (
        <div
            className={cls.container}
            style={{ top: `${coordinate.y}%`, left: `${coordinate.x}%` }}
        >
            <div ref={dropRef} className={clsDropzone}>
                <div className={cls.dashedBoxWrapper}>
                    <div className={cls.description}>
                        {isCorrect === true ? (
                            <StatusSuccessIcon className={cls.statusIcon} />
                        ) : isCorrect === false ? (
                            <StatusFailedIcon className={cls.statusIcon} />
                        ) : (
                            <>
                                {description} <span className={cls.answer}>{image && `· ${itemToLetter(image[0])}`}</span>
                            </>
                        )}
                        <p className={clsx(cls.descriptionHover, `descriptionHover-dynamic-${description} ${isCorrect !== undefined ? isCorrect ? 'green' : 'red' : '' }`)}>{isCorrect === undefined ? coordinate.hoverText : coordinate.finishText}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};
